import React, { useRef } from "react";
import './contact.css';
import emailjs from '@emailjs/browser'



const Contact = () => {
    const form = useRef();
    const [isLoading, setIsLoading] = React.useState(false);
    const [message, setMessage] = React.useState('');
    const [isError, setIsError] = React.useState(false);

    const sendEmail = (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('');
        setIsError(false);
    
        emailjs.sendForm('service_a12j34o', 'template_7tjjhcb', form.current, 'vl0pHnwumLTXBVgiS')
          .then((result) => {
              console.log(result.text);
              e.target.reset();
              setMessage('Message sent successfully!');
              setIsError(false);
          }, (error) => {
              console.log(error.text);
              setMessage('Failed to send message. Please try again.');
              setIsError(true);
          })
          .finally(() => {
              setIsLoading(false);
          });
      };
    return(
        <section id="contactPage">
            <div id="contact">
                <h1 className="contactPageTitle">Contact Me</h1>
                <span className="contactDesc">Please fill the form for contacting me</span>
                <form className="contactForm" ref={form} onSubmit={sendEmail}>
                    <input type="text" placeholder="Your Name" className="name" name='from_name'/>
                    <input 
                        type="email" 
                        placeholder="Email" 
                        className="email" 
                        name="from_email"
                        required
                    />
                    <input type="text" placeholder="Subject" className="subject" name='subject'/>
                    <textarea placeholder="Message" className="msg" rows="5" name='message'></textarea>
                    <button 
                        type="submit" 
                        value='Send' 
                        className="submitBtn" 
                        disabled={isLoading}
                    >
                        {isLoading ? 'Sending...' : 'Send'}
                    </button>
                    {message && (
                        <div className={`message ${isError ? 'error' : 'success'}`}>
                            {message}
                        </div>
                    )}
                </form>

            </div>
        </section>
    )
}
export default Contact;